var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResetDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 131,
    viewBox: "0 0 130 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3244_95934)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3244_95934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.7915 112.187C81.7915 112.187 99.9543 103.55 89.0619 76.6166L78.8635 78.1001C78.8635 78.1001 83.9225 93.3668 72.4735 100.755L81.7915 112.187Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4735 100.755L81.7915 112.187L70.4609 103.18L72.4735 100.755Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.145 57.1436C37.145 72.2393 49.9045 83.8306 65.5392 83.8306C81.174 83.8306 93.9334 72.2393 93.9334 57.1436C93.9334 42.0479 81.174 29.7378 65.5392 29.7378C49.9045 29.7378 37.145 42.0479 37.145 57.1436Z",
    fill: "white",
    stroke: "#020203",
    strokeWidth: 1.90376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2987 80.5962C78.2987 80.5962 75.1537 70.173 84.7682 80.5962C91.6871 88.0541 94.1132 90.9295 92.1363 107.014C92.1363 107.373 91.6871 113.573 91.5972 113.843C90.7885 119.683 92.945 129.567 100.403 139.99L37.145 151.851C37.145 151.851 43.2552 121.84 42.3566 113.303C40.7392 98.028 46.7595 83.4715 61.316 80.5962C75.8726 77.7208 78.2987 80.5962 78.2987 80.5962Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5333 79.3379L85.397 91.7379L69.4028 82.1234",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2524 93.4453L52.3307 123.187L73.1771 124.625L73.5365 92.4569L51.2524 93.4453Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.517116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9941 89.9402L51.0724 119.682L71.9188 121.12L72.2782 88.9518L49.9941 89.9402Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.517116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2524 92.6361L52.3307 122.378L73.1771 123.816L73.5365 91.7375L51.2524 92.6361Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.517116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5332 94.2538L51.6115 123.996L72.4579 125.434L72.8173 93.2654L50.5332 94.2538Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.517116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6348 95.2423L50.713 124.984L71.5594 126.422L71.9188 94.2539L49.6348 95.2423Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.517116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6523 98.7465L67.8755 98.3871L67.7857 102.251L63.9219 102.61L63.6523 98.7465Z",
    stroke: "#9D9D9C",
    strokeWidth: 0.392487,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0117 103.599L68.1451 103.239V107.103L64.2813 107.462L64.0117 103.599Z",
    stroke: "#9D9D9C",
    strokeWidth: 0.392487,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4902 96.6798L50.7134 124.984L70.212 124.715L69.0439 95.6914L46.4902 96.6798Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.517116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8321 98.0275C63.8321 98.0275 67.6959 114.022 66.348 124.984L49.006 123.816C49.006 123.816 51.7017 107.193 43.9741 99.3753L63.8321 98.0275Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.517116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2373 108.631L64.6402 108.181L65.0895 112.045L60.5069 112.494L60.2373 108.631Z",
    stroke: "#9D9D9C",
    strokeWidth: 0.392487,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2694 113.123C64.9998 109.439 69.9418 107.912 73.2665 109.709C76.5911 111.506 75.8723 116.538 75.3331 118.515C74.6143 121.39 70.7505 121.031 68.0549 120.042C65.2694 119.144 65.5389 116.718 65.2694 113.123Z",
    fill: "white",
    stroke: "#020203",
    strokeWidth: 1.37415,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2209 113.662L72.0991 113.213",
    stroke: "#020203",
    strokeWidth: 1.44307,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1306 117.257L71.7393 116.538",
    stroke: "#020203",
    strokeWidth: 1.44307,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7193 120.582C65.6295 120.941 65.3599 121.21 65.0005 121.3C61.3164 121.839 41.6381 124.445 37.6845 114.921C33.3715 104.408 33.8207 86.167 56.8237 79.4279L61.6758 87.5148C61.6758 87.5148 53.9483 88.5931 51.2526 89.6713C48.557 90.7496 49.9048 92.0076 47.0294 94.7931C44.0642 97.6685 42.1773 99.825 44.7831 104.408C48.7367 111.506 67.786 108.541 67.786 108.541L65.7193 120.582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1275 136.396L83.5999 162.813H75.9622L71.5593 136.396H65.6289V162.813H57.2724L54.1274 133.79L84.6782 126.152L85.1275 136.396Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.145 57.4135C37.145 72.5092 49.9045 84.1005 65.5392 84.1005C81.174 84.1005 93.9334 72.5092 93.9334 57.4135C93.9334 42.3178 81.174 30.0077 65.5392 30.0077C49.9045 30.0077 37.145 42.228 37.145 57.4135Z",
    fill: "white",
    stroke: "#020203",
    strokeWidth: 1.90376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5738 23.3581C62.5738 23.3581 83.3303 13.4741 92.4955 36.2973C100.313 55.7958 99.0549 52.8306 103.727 58.4016C108.4 63.8828 90.0694 75.5639 90.6086 68.2857C91.5071 56.0654 91.0578 33.0625 70.7506 34.0509C59.6085 34.59 57.3622 35.1291 56.3738 44.6538C55.3854 54.1784 59.4288 53.2799 60.5071 61.0074C61.6752 69.0944 57.7216 90.7495 26.0926 89.4915C26.0926 89.4915 43.9738 85.8074 30.6752 75.6538C17.3766 65.5002 18.1853 13.0248 62.5738 23.3581Z",
    fill: "#EA6463"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M37.145 57.1436C37.145 72.2393 49.9045 83.8306 65.5392 83.8306C81.174 83.8306 93.9334 72.2393 93.9334 57.1436C93.9334 42.0479 81.174 29.7378 65.5392 29.7378C49.9045 29.7378 37.145 42.0479 37.145 57.1436Z",
    stroke: "#020203",
    strokeWidth: 1.90376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0872 54.358C73.0872 54.358 66.7075 53.8189 67.5162 60.1087",
    stroke: "black",
    strokeWidth: 1.39213,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4321 51.1232C82.4321 51.1232 79.6466 50.6739 79.0176 53.4594",
    stroke: "black",
    strokeWidth: 1.57013,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.426 58.042L65.7188 57.6826",
    stroke: "black",
    strokeWidth: 1.39213,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5954 55.2583L67.8755 54.3584",
    stroke: "black",
    strokeWidth: 1.39213,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8896 99.1955L63.1128 98.8361L63.7418 102.7L59.1592 103.059L58.8896 99.1955Z",
    stroke: "#9D9D9C",
    strokeWidth: 0.392487,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.519 103.958L64.0118 103.509L64.3712 107.373L59.8785 107.732L59.519 103.958Z",
    stroke: "#9D9D9C",
    strokeWidth: 0.392487,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.439 72.7809C75.439 72.7809 79.9261 76.1228 82.0629 73.8239C82.0629 73.8239 83.4609 72.5314 78.1653 72.9689L75.439 72.7809Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1068 72.512C79.0282 74.8714 79.3772 78.4977 81.8143 80.6237C83.7394 82.2775 86.076 80.9821 88.9265 79.8935C91.9023 78.7745 91.3522 74.8656 90.4987 71.8917L90.0568 70.3422C88.7538 64.6942 87.4736 64.607 86.2522 65.0356C85.2034 65.3561 85.5391 68.6543 86.1043 70.439C86.1043 70.439 82.3984 71.0061 81.1068 72.512Z",
    fill: "white",
    stroke: "#020203",
    strokeWidth: 1.34829,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.6255,
    y1: 129.819,
    x2: 106.125,
    y2: 129.819,
    stroke: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3244_95934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    fill: "white",
    transform: "translate(0 0.166626)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3244_95934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116.812,
    height: 169.826,
    fill: "white",
    transform: "translate(6.59424 7.9928)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetDefault);
export default __webpack_public_path__ + "static/media/reset-default.a604548653f4272f135596c37c013306.svg";
export { ForwardRef as ReactComponent };